<template>
    <div class="hidden lg:flex" :class="[btnClass]" @click="clickBack()">
        <img class="back-icon" src="@/assets/arrow/back-btn.svg">
    </div>
</template>

<script>
import CookieMixin from '@/mixin/CookieMixin';
export default {
    name: "BackButtonDesktop",
    mixins: [CookieMixin],
    props: {
        customClass: { type: String, default: null },
    },
    computed: {
        btnClass: function() {
            if (this.customClass != null) {
                return this.customClass;
            }
            return 'absolute left-6 pt-6 ' + this.cookieClass;
        },
    },
    methods: {
        clickBack: function() {
            this.$emit('clickBack');
        }
    }
}
</script>
<style lang="scss" scoped>
    .accept-cookie {
        padding-top: 24px;
    }
</style>
